export default {"src":"/_next/static/media/shareWhatsappBlue.d7df2bc3.svg","height":32,"width":32};